import { intlReducer } from '@tmapy/intl';

import { uiManager } from '@tmapy/ui-manager';
import { mapSearch } from '@tmapy/map-search';
import { mapSwitcher } from '@tmapy/map-switcher';

import { app } from '../app/reducer';
import { resourceReducer } from './resource/reducer';
import { doc } from '../docs/reducers/docDetail';
import { docedit } from '../docs/reducers/docEdit';
import { newOrder } from '../orders/reducers/newOrder';
import { orderDetail } from '../orders/reducers/orderDetail';

import { filter } from './filter/reducer';
import { menu } from './menu/reducer';
import { mapCore } from './mapCore';

declare module '@tmapy/redux' {
  interface AppState {
    app: ReturnType<typeof app>;
    resource: ReturnType<typeof resourceReducer>;
    doc: ReturnType<typeof doc>;
    docedit: ReturnType<typeof docedit>;
    newOrder: ReturnType<typeof newOrder>;
    orderDetail: ReturnType<typeof orderDetail>;

    filter: ReturnType<typeof filter>;
    menu: ReturnType<typeof menu>;
    mapCore: ReturnType<typeof mapCore>;
    mapSearch: ReturnType<typeof mapSearch>;
    mapSwitcher: ReturnType<typeof mapSwitcher>;
  }
}

/**
 * Root reducer
 */
export const reducers: any = {
  app,
  intl: intlReducer,
  resource: resourceReducer,
  doc,
  uiManager,
  docedit,
  newOrder,
  orderDetail,
  mapCore,

  mapSearch,
  mapSwitcher,
  filter,
  menu,
};
